type DateRange = [Date, Date];

export function hasMinimumCalendarDays(
  [start, end]: DateRange,
  minimumDays: number,
): boolean {
  const startUtc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
  const endUtc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  const differenceInDays = Math.abs(endUtc - startUtc) / 86_400_000;

  return differenceInDays + 1 >= minimumDays;
}
